import React, { useState } from 'react';
import { pdf } from '@react-pdf/renderer';
import ConfirmationDialog from '../../../components/dialogs/ConfirmationDialog';
import NewPreemiePDFDocument from './NewPreemiePDF';
import { loadPDFData } from './utils/pdfDataLoader';

export const NewPreemiePDFExportButton: React.FC = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [motherName, setMotherName] = useState('');
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    if (!motherName.trim()) {
      alert('נא להזין שם אם');
      return;
    }

    setIsExporting(true);

    try {
      // Load PDF data
      const data = loadPDFData(motherName);

      // Generate PDF
      const blob = await pdf(<NewPreemiePDFDocument data={data} />).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      // Filename: "קבלת-פג-[mother-name]-[date].pdf"
      const safeMotherName = motherName.replace(/\\s+/g, '_');
      const dateStr = new Date().toISOString().split('T')[0];
      link.download = `קבלת-פג-${safeMotherName}-${dateStr}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      // Reset and close
      setIsDialogOpen(false);
      setMotherName('');
    } catch (error) {
      console.error('PDF generation error:', error);
      alert('שגיאה ביצירת קובץ PDF. אנא נסה שנית.');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setIsDialogOpen(true)}
        className="btn btn-update"
        style={{
          display: 'block',
          margin: '20px auto',
          padding: '12px 24px',
        }}
      >
        ייצא לקובץ
      </button>

      <ConfirmationDialog
        open={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false);
          setMotherName('');
        }}
        onCancel={() => {
          setIsDialogOpen(false);
          setMotherName('');
        }}
        onConfirm={handleExport}
        title="ייצוא ל-PDF"
        description="הזן את שם האם לייצוא הקובץ"
        confirmText={isExporting ? 'מייצא...' : 'ייצא ל-PDF'}
        cancelText="ביטול"
      >
        <input
          type="text"
          data-clarity-mask="true"
          value={motherName}
          onChange={(e) => setMotherName(e.target.value)}
          placeholder="שם האם"
          disabled={isExporting}
          style={{
            width: '100%',
            padding: '12px',
            fontSize: '1rem',
            border: '1px solid #ccc',
            borderRadius: '8px',
            textAlign: 'right',
            direction: 'rtl',
          }}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !isExporting) {
              handleExport();
            }
          }}
        />
      </ConfirmationDialog>
    </>
  );
};

export default NewPreemiePDFExportButton;
